import Box from "@mui/material/Box";
import ReactAudioPlayer from "react-audio-player";
import i18n from "../../../../../../../constants/i18n";
import configuration from "../../../../../../../configuration/keys";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import { getAttachmentName } from "../../../../../../../helpers/et3-conversation-parse";
import getCoreHistoryStore from "../../../../../../../stores/core/core-history-store";
import KhattabatMessageText from "./KhattabatMessageText";

const KhattabatMessageContent = withLiteObserverAndTheme<{
  message: string;
  messageType: string;
}>((props) => {
  const { message, messageType } = props;

  switch (messageType) {
    case "text":
    case "automated":
      return <KhattabatMessageText text={message} />;
    case "sticker":
      return <KhattabatMessageText text={`ALKHATTABA_APP_STICKER_${message}`} />;
    case "picture": {
      const imageUrl = `${configuration.imageAttachmentUrl}${getAttachmentName(message)}`;
      return (
        <Box
          component="img"
          src={imageUrl}
          alt={i18n.get("PICTURE")}
          loading="lazy"
          onClick={() => getCoreHistoryStore().openNewTab(imageUrl)}
          sx={{
            display: "block",
            maxWidth: 200,
            maxHeight: 200,
            borderRadius: 1,
            cursor: "pointer"
          }}
        />
      );
    }
    case "voice":
      return (
        <ReactAudioPlayer
          src={`${configuration.voiceAttachmentUrl}${getAttachmentName(message)}`}
          autoPlay={false}
          controls
          style={{ maxWidth: "100%" }}
        />
      );
    default:
      return null;
  }
});

export default KhattabatMessageContent;
